import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ModalCloseIcon } from "../../assets/svg/close-modal.svg";
import { ReactComponent as MinusSign } from "../../assets/svg/minus-sign.svg";
import { ReactComponent as PlusSign } from "../../assets/svg/add-circle.svg";
import { Container, Row, Col } from "react-bootstrap";
import "../visitor/visitor-create/visitor-create.css";
import DOMPurify from 'dompurify';
import SearchWithAPI from "../common/searchbox/searchbox.js";
import { ReactComponent as AddItem } from "../../assets/svg/add_item.svg";
import deleteIcon from "../../assets/svg/delete.svg";
import { createCheckListApi, getCheckListDetailsApi, updateCheckListApi } from "./setup-api.js";
const ChecklistCreateModal = ({ checkId, onSuccess, onCancel }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "end",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",


      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "618px",
      height: "100vh",
      overflowY: "auto",
    },
  };


  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [moduleType, setModuleType] = useState("Visitor");
  const [checkList, setCheckList] = useState([{ 'checkname': '', 'creteria': 'Boolean', 'value': 'true', 'minvalue': '', 'maxvalue': '' }]);
  const [locationOption, setLocationOption] = useState(null);
  useEffect(() => {
    if (checkId != null) {
      getCheckListDetails()
    }
  }, []);


  const [validations, setValidations] = useState({
    "code": "",
    "name": "",
    "type": "",
    "location_id": "",
    "checklist_names": "",
  });
  const getCheckListDetails = async () => {
    try {
      const response = await getCheckListDetailsApi(checkId);
      if (response.status === true) {
        console.log(response)
        var checkListDetails = response.Checklist;
        setCode(checkListDetails.code ?? '')
        setName(checkListDetails.name ?? '')
        setLocationOption({ 'value': checkListDetails.location_id ?? '', 'label': checkListDetails.location ?? '' })
        setModuleType(checkListDetails.type ?? '')
        setCheckList(checkListDetails.checks ?? [])
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const submitCheckList = async () => {

    const dataBeforeSanitize = {
      "id": checkId != null ? checkId : "",
      "code": code,
      "name": name,
      "type": moduleType,
      "location_id": locationOption != null ? locationOption.value : '',
      "checklist_names": checkList,
    };
    const dataAfterSanitize = {};
    Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
      if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === "checklist_names") {
        dataAfterSanitize[key] = value;
      } else {
        dataAfterSanitize[key] = DOMPurify.sanitize(value);
      }
    });
    if (checkId == null) {
      const response = await createCheckListApi(dataAfterSanitize);
      if (response.status === 200) {
        if (response.data.status === true) {
          onSuccess(response.data)
        }
      }

      if (response.status === 400) {
        new Promise((resolve, reject) => {

          const validationTemp = {
            "code": "",
            "name": "",
            "dimensiontype": "",
            "length": "",
            "width": "",
            "height": "",
            "duration": "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? '' : value[0];
          });
          console.log('validationTemp...', validationTemp);
          setValidations(validationTemp);
        });
      }
    } else {
      const response = await updateCheckListApi(dataAfterSanitize, checkId);
      if (response.status === 200) {
        if (response.data.status === true) {
          onSuccess(response.data)
        }
      }

      if (response.status === 400) {
        new Promise((resolve, reject) => {

          const validationTemp = {
            "code": "",
            "name": "",
            "dimensiontype": "",
            "length": "",
            "width": "",
            "height": "",
            "duration": "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? '' : value[0];
          });
          console.log('validationTemp...', validationTemp);
          setValidations(validationTemp);
        });
      }
    }
  };

  const handleLocationDropdownChange = (option) => {
    console.log(option)
    setLocationOption(option)
  };
  return (<div style={modalStyle.overlay}>
    <div style={modalStyle.modal}>
      <div style={{ color: "#ffffff" }}>
        <div className="modal-header style-justify-between"
        >
          <div className="add-item-modal-title"
          >
            Add check list
          </div>
          <ModalCloseIcon
            style={{ cursor: "pointer" }}
            onClick={onCancel}
          />
        </div>

        <div style={{ padding: "16px 16px", }}>
          <Row style={{ width: '610px' }}>
            <Col xs={12} sm={12} md={6} className="mt-2">
              <div className="field-title">
                Code<span style={{ color: '#FF4444' }}>*</span>
              </div>
              <input
                type="text"
                placeholder="Enter here..."
                className="input-field mt-2 w-100"
                value={code}
                onChange={(event) => {
                  setCode(event.target.value); // Update state with input value
                }}
              />
              <span className="field-error" >{validations.code}</span>
            </Col>
            <Col xs={12} sm={12} md={6} className="mt-2">
              <div className="field-title">
                Name<span style={{ color: '#FF4444' }}>*</span>
              </div>
              <input
                type="text"
                placeholder="Enter here..."
                className="input-field mt-2 w-100"
                value={name}
                onChange={(event) => {
                  setName(event.target.value); // Update state with input value
                }}
              />
              <span className="field-error" >{validations.name}</span>
            </Col>
            <Col xs={12} sm={12} md={6} className="mt-2">
              <div className="field-title">
                Type<span style={{ color: '#FF4444' }}>*</span>
              </div>
              <select className="select3 w-100 input-field mt-2" id="moduletype" value={moduleType} onChange={(event) => { setModuleType(event.target.value); }} style={{ cursor: 'pointer', fontSize: '14px', fontWeight: '500', lineHeight: '18.9px', color: '#8790A1', height: '40px', borderRadius: '10px', border: '0.7px solid #E5E5E5', padding: '0 8px', gap: '77px', backgroundColor: '#FFFFFF' }}>
                <option value="Visitor">Visitor</option>
                <option value="Vehicle">Vehicle</option>
                <option value="Courier">Courier</option>
              </select>
              <span className="field-error" >{validations.type}</span>
            </Col>


            <Col xs={12} sm={12} md={6} className="mt-2">
              <div className="field-title mb-2">
                Location<span style={{ color: '#FF4444' }}>*</span>
              </div>
              <SearchWithAPI onDropdownChange={handleLocationDropdownChange} apiUrl={adminApiUrl + "get_location"} params={{ 'checklist_type': moduleType }} placeholder={"Location"} selectedOption={locationOption} />
              <span className="field-error" >{validations.location_id}</span>
            </Col>
          </Row>

          <Row className="mt-2" style={{ width: '610px' }}>
            <Col sm={12} lg={12} className="mt-3">

              <div className="item-list-header" style={{ flex: '12', }}>

                <span className="item-list-header-txt style-justify-start" style={{ flex: '3' }}>Check Name</span>
                <span className="item-list-header-txt style-justify-start" style={{ flex: '2' }}>Criteria</span>
                <span className="item-list-header-txt style-justify-start" style={{ flex: '2' }}>Value</span>
                <span className="item-list-header-txt style-justify-start" style={{ flex: '2' }}>Min. Value</span>
                <span className="item-list-header-txt style-justify-start" style={{ flex: '3' }}>Max. Value</span>

              </div>
              <div>
                {checkList.map((check, index) => (
                  <div key={'item-list' + index} style={{ position: "relative" }}>

                    <div className="item-list-row" style={{ flex: '12', }}>

                      <span className="item-list-row-txt" style={{ flex: '3', padding: '0px' }}><input
                        type="text"
                        placeholder=" "
                        className="input-field w-100"
                        value={check.checkname}
                        style={{ borderRadius: '0px', border: 'none' }}
                        onChange={(event) => {
                          const tempCheckList = [...checkList];
                          tempCheckList[index].checkname = event.target.value
                          setCheckList(tempCheckList);
                        }}
                      /></span>
                      <span className="item-list-row-txt" style={{ flex: '2', padding: '0px' }}>
                        <select className="select3 w-100 input-field" id={"criteria" + index} value={check.creteria}
                          onChange={(event) => {
                            const tempCheckList = [...checkList];
                            tempCheckList[index].creteria = event.target.value;
                            setCheckList(tempCheckList);
                          }} style={{ cursor: 'pointer', fontSize: '14px', fontWeight: '500', lineHeight: '18.9px', color: '#8790A1', height: '40px', borderRadius: '0px', border: 'none', padding: '0 8px', gap: '77px', backgroundColor: '#FFFFFF' }}>
                          <option value="Boolean">Boolean</option>
                          <option value="Range">Range</option>
                        </select>
                      </span>

                      <span className="item-list-row-txt" style={{ flex: '2', padding: '0px' }}>
                        {check.creteria === 'Boolean' && (<select className="select3 w-100 input-field" id={"value" + index} value={check.value}
                          onChange={(event) => {
                            const tempCheckList = [...checkList];
                            tempCheckList[index].value = event.target.value;
                            setCheckList(tempCheckList);
                          }}
                          style={{ cursor: 'pointer', fontSize: '14px', fontWeight: '500', lineHeight: '18.9px', color: '#8790A1', height: '40px', borderRadius: '0px', border: 'none', padding: '0 8px', gap: '77px', backgroundColor: '#FFFFFF' }}>
                          <option value="true">True</option>
                          <option value="false">False</option>
                        </select>)}
                      </span>
                      <span className="item-list-row-txt" style={{ flex: '2', padding: '0px' }}>
                        {check.creteria === 'Range' && (<input
                          type="text"
                          placeholder=" "
                          className="input-field w-100"
                          value={check.minvalue}
                          style={{ borderRadius: '0px', border: 'none' }}
                          onChange={(event) => {
                            const value = event.target.value.replace(
                              /\D/g,
                              ""
                            );
                            const tempCheckList = [...checkList];
                            tempCheckList[index].minvalue = value;
                            setCheckList(tempCheckList);
                          }}
                        />)}
                      </span>
                      <span className="item-list-row-txt" style={{ flex: '3', padding: '0px' }}>
                        {check.creteria === 'Range' && (<input
                          type="text"
                          placeholder=" "
                          className="input-field w-100"
                          value={check.maxvalue}
                          style={{ borderRadius: '0px', border: 'none' }}
                          onChange={(event) => {
                            const value = event.target.value.replace(
                              /\D/g,
                              ""
                            );
                            const tempCheckList = [...checkList];
                            tempCheckList[index].maxvalue = value;
                            setCheckList(tempCheckList);
                          }}
                        />)}
                      </span>

                    </div>
                    <div style={{ position: "absolute", top: "5px", right: "5px", }}>
                      {checkList.length !== 1 && (<img
                        src={deleteIcon}
                        alt="Delete"
                        onClick={() => {
                          const tempCheckList = [...checkList];
                          tempCheckList.splice(index, 1);
                          setCheckList(tempCheckList);
                        }}
                        style={{ width: "30px", height: "30px" }}
                      />)}
                    </div>

                  </div>))}
              </div>
              <div className="mt-2 style-justify-start">
                <div
                  className="add-item-btn style-justify-center" style={{ width: '150px' }}
                  onClick={() => {
                    const tempCheckList = [...checkList];
                    tempCheckList.push({ 'checkname': '', 'creteria': 'Boolean', 'value': 'true', 'minvalue': '', 'maxvalue': '' });
                    setCheckList(tempCheckList);
                  }}
                >
                  <AddItem />
                  <div >
                    Add checklist
                  </div>
                </div>
              </div>
            </Col>

          </Row>






          <Row className="mt-3" style={{ width: '610px' }}
          >
            <div className="style-justify-end">
              <div
                onClick={onCancel} className="cancel-modal-btn style-justify-center"
              >
                Cancel
              </div>
              <div className="save-modal-btn style-justify-center"
                onClick={(e) => {
                  submitCheckList()

                }}>
                Save
              </div>
            </div>
          </Row>
        </div>
      </div>
    </div>
  </div>);

}

export default ChecklistCreateModal;